import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	inProgressIssuesTooltipText: {
		id: 'version-progress.issue-progress-bar.in-progress-issues-tooltip-text',
		defaultMessage:
			'In Progress: {inProgressIssueCount} of {totalIssueCount} {totalIssueCount, plural, one {issue} other {issues}}',
		description: 'Tooltip for the In Progress segment of the progress bar in version page.',
	},
	doneIssuesTooltipText: {
		id: 'version-progress.issue-progress-bar.done-issues-tooltip-text',
		defaultMessage:
			'Done: {completedIssueCount} of {totalIssueCount} {totalIssueCount, plural, one {issue} other {issues}}',
		description: 'Tooltip for the Done segment of the progress bar in version page.',
	},
	todoIssuesTooltipText: {
		id: 'version-progress.issue-progress-bar.todo-issues-tooltip-text',
		defaultMessage:
			'To Do: {todoIssueCount} of {totalIssueCount} {totalIssueCount, plural, one {issue} other {issues}}',
		description: 'Tooltip for the To Do segment of the progress bar in version page.',
	},
	inProgressIssuesTooltipTextIssueTerminologyRefreshM4: {
		id: 'version-progress.issue-progress-bar.in-progress-issues-tooltip-text-issue-terminology-refresh-m4',
		defaultMessage:
			'In Progress: {inProgressIssueCount} of {totalIssueCount} {totalIssueCount, plural, one {work item} other {work items}}',
		description: 'Tooltip for the In Progress segment of the progress bar in version page.',
	},
	doneIssuesTooltipTextIssueTerminologyRefreshM4: {
		id: 'version-progress.issue-progress-bar.done-issues-tooltip-text-issue-terminology-refresh-m4',
		defaultMessage:
			'Done: {completedIssueCount} of {totalIssueCount} {totalIssueCount, plural, one {work item} other {work items}}',
		description: 'Tooltip for the Done segment of the progress bar in version page.',
	},
	todoIssuesTooltipTextIssueTerminologyRefreshM4: {
		id: 'version-progress.issue-progress-bar.todo-issues-tooltip-text-issue-terminology-refresh-m4',
		defaultMessage:
			'To Do: {todoIssueCount} of {totalIssueCount} {totalIssueCount, plural, one {work item} other {work items}}',
		description: 'Tooltip for the To Do segment of the progress bar in version page.',
	},
	noIssuesText: {
		id: 'version-progress.issue-progress-bar.no-issues-text',
		defaultMessage: 'No work items',
		description: 'No issues text for progress bar in version page.',
	},
});
